import React, {useState} from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Recommended ({sendMessage,messageDetails}) {
    const [openCard, setopenCard] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const searchHandler =(e)=>{
        var lowerCase = e.target.value.toLowerCase();
        setSearchValue(lowerCase);
    }
    const filteredData = messageDetails?.buttons.filter((el) => {
        if (searchValue === '') {
            return el;
        }
        else {
            return el?.title?.toLowerCase().includes(searchValue)
        }
    })
    return (
        <>
            <div className="quick-msg-btn-wrapper">
                <span className="recommended-text">Recommendations</span>
                {
                    messageDetails?.buttons?.map((buttons, i) => (
                        i<2 &&
                        <button type="button" className="btn-outline" onClick={(e)=>sendMessage(buttons)} key={i}>{buttons.title}</button>
                    ))
                }
                <div className="quick-toggler" onClick={()=> setopenCard(!openCard)}>
                    More ({messageDetails?.buttons?.filter(component => component.mode === "quickreply").length-2}) <ExpandMoreIcon />
                </div>
            </div>
            { 
                openCard ?
                    <div className="drawer-overlay" onClick={() => setopenCard(false)}></div>
                : null
            }
            <div className={`leave-message-wrapper ${openCard ? "show-leave-form" : ""}`}>
                    <div className="drawer-header">
                        <input type="text" placeholder="Search here..." className="form-control" value={searchValue} onChange={(e)=>searchHandler(e)} />
                    </div>
                    <div className="drawer-body">
                        <ul className="quick-btn-list-wrapper">
                            {
                                filteredData?.map((buttons, i) => {
                                    return(
                                        <li onClick={(e)=>{sendMessage(buttons);setopenCard(false)}} key={i}><CheckCircleIcon /> {buttons.title}</li>
                                    )
                                })
                            }
                            {
                                filteredData.length < 1 && <div style={{textAlign:"center"}}>No record found</div>
                            }
                        </ul>
                    </div>
            </div>
        </>
    )
}
export default Recommended